import { render, staticRenderFns } from "./WaiterTemplateSelectItem.vue?vue&type=template&id=2e44f1c8&scoped=true&lang=pug"
import script from "./WaiterTemplateSelectItem.vue?vue&type=script&lang=ts"
export * from "./WaiterTemplateSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./WaiterTemplateSelectItem.vue?vue&type=style&index=0&id=2e44f1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e44f1c8",
  null
  
)

export default component.exports